import { Model } from 'modules/core/lib/mobx-rest'

export interface ICard {
  type: string
  name: string
  last4: string
  brand: string
  exp_month: number
  exp_year: number
  country?: string | null
}

class Card extends Model<ICard> {
  static urlRoot() {
    return '/billing/cards'
  }
}

export default Card
